<mat-card class="m-2 p-0">
    <div fxLayout="row wrap" fxLayoutAlign="space-between center" class="w-100 p-2">
        <div></div>
        <button mat-raised-button color="primary" routerLink="/compte-utilisateur/ajoute-sinistre">
            <mat-icon>add</mat-icon>
            Declarer un Nouveau Sinistre
        </button>
    </div>
    <mat-divider></mat-divider>

    <div fxLayout="row" fxLayoutAlign="space-between center" class="p-2" class="search">
        <div fxLayout="row">
            <button  mat-icon-button  color="primary" matTooltip="Affichage en Grille" (click)="changeViewType('grid')">
                <span><mat-icon>grid_view</mat-icon></span>
            </button>
            <button  mat-icon-button  color="primary" matTooltip="Affichage en Liste" (click)="changeViewType('list')">
                <span><mat-icon>format_list_bulleted</mat-icon></span>
            </button>
            <mat-button-toggle-group #controls="matButtonToggleGroup" appearance="legacy">            
    
                <mat-button-toggle value="search" *ngIf="viewType==='list'">
                    <mat-icon>search</mat-icon>
                </mat-button-toggle>           
            </mat-button-toggle-group>            
        </div>
        <form class="user-search" [class.show]="controls.value == 'search'">
            <mat-form-field class="user-search-input">
                <input matInput placeholder="Recherche d'un sinistre..." (keyup)="applyFilter($event)" name="search">
            </mat-form-field>
        </form>
    </div>

    <div class="table-wrapper" *ngIf="viewType==='list'">

        <table mat-table [dataSource]="dataSource" matSort class="w-100">

            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> N° </th>
                <td mat-cell *matCellDef="let car">{{car.id}} </td>
            </ng-container>
            <ng-container matColumnDef="marque">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Marque </th>
                <td mat-cell *matCellDef="let car">{{car.vehicle_mark}} {{car.vehicle_model}} </td>
            </ng-container>
            <ng-container matColumnDef="model">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Lieu du sinistre </th>
                <td mat-cell *matCellDef="let car">{{car.lieu_sinistre}} </td>
            </ng-container>
            <ng-container matColumnDef="lieu_actuel">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Position actuel</th>
                <td mat-cell *matCellDef="let car">{{car.lieu_actuel_vehic}} </td>
            </ng-container>
            <ng-container matColumnDef="lieu_Accident">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>lieu Accident</th>
                <td mat-cell *matCellDef="let car">{{car.lieu_sinistre}} </td>
            </ng-container>
            <ng-container matColumnDef="NomPorprio">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>proprietaire </th>
                <td mat-cell *matCellDef="let car">{{car.NomPorprio}} </td>
            </ng-container>

            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Date du Sinistre </th>
                <td mat-cell *matCellDef="let car">{{car.date_sinistre}} </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Statut</th>
                    <td mat-cell *matCellDef="let sinister" >
                        <button mat-button [matMenuTriggerFor]="menu">{{sinister.status}} <mat-icon>expand_more</mat-icon> </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="changeStatus(sinister.id,'Enregistré')" disabled="true">Enregistré</button>
                            <button mat-menu-item (click)="changeStatus(sinister.id,'Annulé')" [disabled]="sinister.status=='Cloturé' || sinister.status=='Annulé'">Annuler</button>
                        </mat-menu>
                    </td>  
            </ng-container>
            
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> Actions </th>

                <td mat-cell *matCellDef="let car">
                    <button mat-icon-button color="primary" (click)="edit(car.id)" matTooltip="select">
                        Detail
                    </button>
                 
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let car; columns: displayedColumns;"></tr>
        </table>
        <p *ngIf="dataSource && dataSource.data.length === 0" class="py-5 mb-0 text-center">No data available</p>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="center" class="w-100 p-2" *ngIf="viewType==='grid'">
        <mat-card class="menu-item" [fxLayout]="(viewType == 'grid') ? 'column' : 'row'"
            [ngClass]="[viewType + '-item', 'column-'+column]" fxFlex.gt-sm="30" fxFlex.sm="30" *ngFor="let item of resultcat | paginate: { itemsPerPage: 10, currentPage: p }">
            
            <div fxFlex="100" class="p-3">
                <div fxLayout="column" fxLayoutAlign="start stretch" class="h-100">
                    <mat-card-content class="mb-0">
                        <div class="grand-title">
                            <mat-icon class="icon-title">warning_amber</mat-icon> <br>
                            <!-- <h1 class="title">N°_2568487952136955789</h1> -->
                            <span class="subtitle">{{item.id}}</span>
                        </div>
                        <div>
                            <h1></h1>
                        </div>
                        <div class="mt-2 mb-2"> 
                            <div class="features">
                                <p fxLayout="row" fxLayoutAlign="start center end" class="mb-1 desc-car">
                                    <span class="px-1"><mat-icon class="icon-desc">bookmarks</mat-icon> Marque</span>
                                    <span class="dots"></span>
                                    <span class="fw-500">{{item.vehicle_mark}} {{item.vehicle_model}}</span>
                                </p>
                                <p fxLayout="row" fxLayoutAlign="start center end" class="mb-1 desc-car">
                                    <span class="px-1"><mat-icon class="icon-desc">person</mat-icon> Proprietaire</span>
                                    <!-- <span class="px-1">Modèle:</span> -->
                                    <span class="dots"></span>
                                    <span class="fw-500">{{item.NomPorprio}}</span>
                                </p>
                                <p fxLayout="row" fxLayoutAlign="start center end" class="mb-1 desc-car">
                                    <span class="px-1"><mat-icon class="icon-desc">crisis_alert</mat-icon> Lieu Accident</span>
                                    <!-- <span class="px-1">Modèle:</span> -->
                                    <span class="dots"></span>
                                    <span class="fw-500">{{item.lieu_sinistre}} </span>
                                </p>

                                <p fxLayout="row" fxLayoutAlign="start center end" class="mb-1 desc-car">
                                    <span class="px-1"><mat-icon class="icon-desc">fmd_bad</mat-icon> Position Actuel</span>
                                    <!-- <span class="px-1">Modèle:</span> -->
                                    <span class="dots"></span>
                                    <span class="fw-500">{{item.lieu_actuel_vehic}}</span>
                                </p>

                                <p fxLayout="row" fxLayoutAlign="start center end" class="mb-1 desc-car">
                                    <span class="px-1"><mat-icon class="icon-desc">event</mat-icon> Date</span>
                                    <!-- <span class="px-1">Modèle:</span> -->
                                    <span class="dots"></span>
                                    <span class="fw-500">{{item.date_sinistre | date:"dd MMMM, yyyy 'a' HH:mm" }}</span>
                                </p>

                                <p fxLayout="row" fxLayoutAlign="start center end" class="mb-1 desc-car">
                                    <span class="px-1"><mat-icon class="icon-desc">star</mat-icon> Statut</span>
                                    <!-- <span class="px-1">Modèle:</span> -->
                                    <button mat-button [matMenuTriggerFor]="menu">{{item.status}} <mat-icon>expand_more</mat-icon> </button>
                                    <mat-menu #menu="matMenu">
                                        <button mat-menu-item (click)="changeStatus(item.id,'Enregistré')" disabled="true">Enregistré</button>
                                        <button mat-menu-item (click)="changeStatus(item.id,'Annulé')" [disabled]="item.status=='Cloturé' || item.status=='Annulé'">Annuler</button>
                                    </mat-menu>
                                </p>
                            </div>
                        </div>
                    </mat-card-content>
                    <mat-card-actions class="m-0 p-0">
                        <div class="divider mt-1">
                            <div style="text-align:center">
                                <button mat-icon-button color="primary" (click)="edit(item.id)" matTooltip="select">
                                    Detail
                                </button>
                            </div>
                        </div>
                    </mat-card-actions>
                </div>
            </div>
        </mat-card>
        <p *ngIf="resultcat && resultcat.length === 0" class="py-5 mb-0 text-center">No data available</p>
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="space-between" class="w-100 p-2">
        <div fxFlex="100" fxFlex.gt-sm="20" fxFlex.sm="20">
            <button  mat-icon-button  color="primary" matTooltip="Rafraichir" (click)="refresh()">
                <span><mat-icon>refresh</mat-icon> Mise à jour</span>
            </button>
        </div>
        
        <div fxFlex="100" fxFlex.gt-sm="80" fxFlex.sm="80" *ngIf="viewType==='grid'">
            <pagination-controls (pageChange)="p = $event" style="text-align: end;"></pagination-controls>
        </div>
        <mat-paginator [pageSizeOptions]="[5, 10, 25, 50]" class="{{viewType==='list' ? 'block' : 'hidden'}}" ></mat-paginator>
    </div>
</mat-card>



